import React from 'react';
import { FadeUp } from './FadeUp';
export function ClosingCTA() {
  return <section id="cierre" className="relative z-10 text-center py-[120px] px-6 overflow-hidden" data-id="element-51">
      {/* Center Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-[radial-gradient(ellipse,rgba(0,229,255,0.06)_0%,transparent_70%)] pointer-events-none" data-id="element-52" />

      <div className="max-w-[900px] mx-auto relative z-10" data-id="element-53">
        <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-blue-electric mb-4" data-id="element-54">
          Your next move
        </span>

        <FadeUp data-id="element-55">
          <h2 className="text-[clamp(22px,3.5vw,32px)] font-heading font-bold uppercase leading-[1.3] tracking-[0.05em] max-w-[680px] mx-auto mt-4 mb-6" data-id="element-56">
            It's not just about growing.
            <br data-id="element-57" />
            It's about making sure that when
            <br data-id="element-58" />
            someone finds you, they{' '}
            <span className="text-cyan" data-id="element-59">trust you.</span>
          </h2>
        </FadeUp>

        <FadeUp delay={0.1} data-id="element-60">
          <p className="text-white-dim text-[17px] max-w-[480px] mx-auto mb-12" data-id="element-61">
            That trust is what turns followers into customers — and customers
            into a community. Start today.
          </p>
        </FadeUp>

        <FadeUp delay={0.2} className="flex flex-col items-center gap-5 relative" data-id="element-62">
          {/* Concentric Pulse Rings */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[80%] w-full h-full pointer-events-none -z-10" data-id="element-63">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[150px] h-[150px] border border-cyan/20 rounded-full animate-[orb-pulse_4s_infinite_ease-in-out]" data-id="element-64" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[250px] h-[250px] border border-cyan/10 rounded-full animate-[orb-pulse_4s_infinite_ease-in-out_1s]" data-id="element-65" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] border border-cyan/5 rounded-full animate-[orb-pulse_4s_infinite_ease-in-out_2s]" data-id="element-66" />
          </div>

          <a href="https://wa.me/12814669544?text=Hey,%20I%20want%20to%20start%20growing%20my%20Instagram" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-cyan text-black font-heading font-bold uppercase text-[15px] px-[52px] py-5 rounded-sm decoration-transparent tracking-[0.1em] transition-all duration-300 ease-in shadow-[0_0_40px_rgba(0,229,255,0.35)] hover:bg-white hover:shadow-[0_0_70px_rgba(0,229,255,0.6)] hover:-translate-y-[3px]" data-id="element-67">
            💬 Get Started Now
          </a>
          <p className="text-[13px] text-white-dim opacity-70" data-id="element-68">
            We reply via{' '}
            <span className="text-cyan font-heading uppercase tracking-[0.05em] text-[11px]" data-id="element-69">
              WhatsApp
            </span>{' '}
            within 24 hours. No commitments.
          </p>
        </FadeUp>
      </div>
    </section>;
}